"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormat = exports.numberFormat = exports.percentageFormat = void 0;
var preventRounding = function (num, numFractionDigits) {
    if (numFractionDigits <= 0) {
        return Math.trunc(num);
    }
    var digitsToKeep = Math.pow(10, numFractionDigits);
    var integralNum = Math.trunc(num * digitsToKeep);
    return integralNum / digitsToKeep;
};
/**
 * The percentage format according to locale
 * @example
 * percentageFormat('en', 12) === '12%'
 * percentageFormat('en', 12, {
 *  numFractionDigits: 2,
 * }) === '12.00%'
 * percentageFormat('en', 12.11) === '12%'
 */
exports.percentageFormat = function (locale, num, options) {
    if (options === void 0) { options = {}; }
    var formatterOptions = {
        style: 'percent',
    };
    // NumberFormat.format 'percent' expects only decimals
    var offset = 100;
    if (options.numFractionDigits) {
        formatterOptions.maximumFractionDigits = options.numFractionDigits;
        formatterOptions.minimumFractionDigits = options.numFractionDigits;
    }
    var formatter = new Intl.NumberFormat(locale, formatterOptions);
    if (options.numFractionDigits) {
        return formatter.format(preventRounding(num, options.numFractionDigits) / offset);
    }
    return formatter.format(num / offset);
};
/**
 * The number format according to locale
 * @example
 * numberFormat('en', 1000.34) === '1,000.34'
 * numberFormat('en', 1000.34, {
 *  numFractionDigits: 0,
 * }) === '1,000'
 * numberFormat('en', 1000, {
 *  numFractionDigits: 2,
 * }) === '1,000.00'
 */
exports.numberFormat = function (locale, num, options) {
    if (options === void 0) { options = {}; }
    var formatterOptions = {
        style: 'decimal',
    };
    if (options.numFractionDigits) {
        formatterOptions.maximumFractionDigits = options.numFractionDigits;
        formatterOptions.minimumFractionDigits = options.numFractionDigits;
    }
    var formatter = new Intl.NumberFormat(locale, formatterOptions);
    if (options.numFractionDigits) {
        return formatter.format(preventRounding(num, options.numFractionDigits));
    }
    return formatter.format(num);
};
/**
 * The currency format according to locale
 * @example
 * currencyFormat('en', 'USD', 23.12) === '$23.12'
 * currencyFormat('en', 'USD', 23.12, {
 *  showCents: false,
 * }) === '$23'
 * currencyFormat('en', 'USD', 23.125, {
 *  roundCentsPastCurrencyMinorUnit: true,
 * }) === '$23.13'
 * currencyFormat('en', 'USD', 23.125, {
 *  roundCentsPastCurrencyMinorUnit: false,
 * }) === '$23.12'
 */
exports.currencyFormat = function (locale, currencyCode, num, options) {
    if (options === void 0) { options = {}; }
    var _a = options.showCents, showCents = _a === void 0 ? true : _a, _b = options.roundCentsPastCurrencyMinorUnit, roundCentsPastCurrencyMinorUnit = _b === void 0 ? true : _b;
    var formatterOptions = {
        style: 'currency',
        currency: currencyCode,
    };
    if (!showCents) {
        formatterOptions.maximumFractionDigits = 0;
        formatterOptions.minimumFractionDigits = 0;
    }
    var formatter = new Intl.NumberFormat(locale, formatterOptions);
    if (showCents && !roundCentsPastCurrencyMinorUnit) {
        var numFractionDigits = formatter.resolvedOptions().minimumFractionDigits;
        var numWithoutRounding = preventRounding(num, numFractionDigits);
        return formatter.format(numWithoutRounding);
    }
    return formatter.format(num);
};
//# sourceMappingURL=numberFormatters.js.map